export default "__VITE_ASSET__C7Yc_EZy__"